import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiPaper = {
  styleOverrides: {
    root: {
      backgroundImage: 'none',
      borderRadius: '14px',
      border: '1px solid rgba(15, 23, 42, 0.06)',
    },
  },
} satisfies Components<Theme>['MuiPaper'];
